<div mat-dialog-content>
    <div fxLayoutAlign="center center">
        <p>
            {{data.msg}}?
        </p>
    </div>
  </div>
  
  
  <div mat-dialog-actions fxLayoutAlign="space-around">
    <button mat-raised-button color="accent" style="width: 40%" (click)="onSend()">{{'SEND' | translate}}</button>
    <button mat-raised-button [mat-dialog-close] style="width: 40%" cdkFocusInitial>{{'CANCEL' | translate}}</button>
  </div>
